import { graphql } from "@cappelendamm/crystallize-types/pim/gql";
import Logger from "@cappelendamm/logger";
export const setPipelineStage = async ({ orderId, pipelineId, stageId }, { client }) => {
    Logger.log("Setting pipeline stage in Crystallize: ", JSON.stringify({ orderId, pipelineId, stageId }));
    const response = await client.pim.request(graphql(`
      mutation SetPipelineStage(
        $orderId: ID!
        $pipelineId: ID!
        $stageId: ID!
      ) {
        order {
          setPipelineStage(
            orderId: $orderId
            pipelineId: $pipelineId
            stageId: $stageId
          ) {
            id
          }
        }
      }
    `), { orderId, pipelineId, stageId });
    return response.order?.setPipelineStage.id;
};
